
export default {
  name: 'AmericanSports',
  values: {
    basketball: true,
    ice_hockey: true,
    american_football: true,
    baseball: true,
  },
  meta: {
    extendable: false,
  },
}
